<script>
    import {fade, fly} from 'svelte/transition';
    import Alert, {ALERTS} from "../stores/alerts";
    import CloseButton from "./controls/CloseButton.svelte";

    const yesHandler = () => {
        if ($Alert.yes_callback) {
            $Alert.yes_callback();
        }
        Alert.hide();
    }

    const noHandler = () => {
        if ($Alert.no_callback) {
            $Alert.no_callback();
        }
        Alert.hide();
    }
</script>

{#if $Alert.type}
    <div class="alert-overlay" transition:fade="{{ duration: 100 }}">
        <div class="alert-panel" in:fly="{{ y: -20, duration: 200 }}">
            {#if $Alert.title}
                <div class="alert-heading">
                    { $Alert.title }
                    <CloseButton on:click="{ noHandler }"/>
                </div>
            {/if}
            <div class="alert-body">
                {@html $Alert.prompt}
            </div>
            <div class="alert-footer"
                 class:text-end={ $Alert.type == ALERTS.CONFIRM || $Alert.type == ALERTS.CONFIRM_EXIT || $Alert.type == ALERTS.DELETE }
                 class:text-center={ $Alert.type == ALERTS.ALERT || $Alert.type == ALERTS.WARNING }>
                {#if $Alert.type === ALERTS.ALERT }
                    <button class="btn btn-link" on:click="{ yesHandler }">Close</button>
                {:else if $Alert.type === ALERTS.CONFIRM } <!-- confirm -->
                    <button class="btn btn-link btn-margin" on:click="{ noHandler }">No</button>
                    <button class="btn btn-primary px-4" on:click="{ yesHandler }">YES</button>
<!--                    <button class="btn btn-default btn-yes" on:click="{ yesHandler }">-->
<!--                        YES-->
<!--                    </button>-->
<!--                    <button class="btn btn-default btn-no" on:click="{ noHandler }">NO</button>-->
                {:else if $Alert.type === ALERTS.DELETE }
                    <button class="btn btn-link btn-margin" on:click="{ noHandler }">Cancel</button>
                    <button class="btn btn-danger" on:click="{ yesHandler }">DELETE</button>
                {:else if $Alert.type === ALERTS.WARNING }
                    <button class="btn btn-link" on:click="{ yesHandler }">Close</button>
                {:else if $Alert.type === ALERTS.CONFIRM_EXIT } <!-- confirm exit -->
                    <button class="btn btn-link btn-margin" on:click="{ yesHandler }">Yes</button>
                    <button class="btn btn-primary px-4" on:click="{ noHandler }">NO</button>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .alert-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9000;
    }

    .alert-panel {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: max-content;
        max-width: 80%;
        background: #fff;
        border-radius: 2px;
        overflow: hidden;
        padding-top: 5px;
    }

    .alert-panel .alert-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 1.2rem;
        color: #6f6f6f;
        border-bottom: 1px solid #c6d2d9;
        padding: 18px 20px;
        margin: 0;
    }

    .alert-panel .alert-body {
        font-size: 1rem;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        padding: 18px 20px;
    }

    .alert-panel .alert-footer {
        border-top: 1px solid #c6d2d9;
        padding: 18px 20px;
    }

    .btn-margin {
        margin-right: 2rem;
    }

    @media (max-width: 575px) {
        .alert-panel {
            max-width: 90%;
            width: 90%;
        }
    }

    @media (min-width: 992px) {
        .alert-panel {
            min-width: 450px;
        }
    }
</style>